import { Grid, TextField } from "@material-ui/core";
import { useForm } from "hooks/useForm";
import React, { useEffect } from "react";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import RegularButton from "components/CustomButtons/Button";
import { initialValues, required } from "./inputValues";
import { accessOptions } from "./tagsOpt";
import { editTagsV2 } from "redux/actions/tags/getTagsAction";
import { addNewTagV2 } from "redux/actions/tags/getTagsAction";

export const FormTags = ({ onClose, isEdit = false, tag = {} }) => {
  const dispatch = useDispatch();
  const { station } = useSelector(({ unitsReducer }) => unitsReducer);
  const { stations, stationsList } = useSelector(({ companies }) => companies);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const {
    inputValues,
    handleInputOnChange,
    handleInputAutoComplete,
    handleNewValues,
    fieldErrors,
    runValidates,
  } = useForm(initialValues, required);
  const { number, access, employeeNumber, idStation } = inputValues;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (runValidates()) return;
    const form = {
      ...inputValues,
      access: access?.value,
      idStation: idStation?.value || station.id,
    };
    isEdit
      ? dispatch(editTagsV2(tag.id, form, onClose))
      : dispatch(addNewTagV2(form, onClose));
  };

  useEffect(() => {
    if (isEdit) {
      handleNewValues({
        number: tag.number,
        access: accessOptions.find((ac) => ac.value === tag.access) || null,
        employeeNumber: tag.employeeNumber,
        idStation: stations[tag.idStation] || null,
      });
    } else if (station) {
      handleNewValues({ idStation: station });
    }
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Numero *"
            name="number"
            value={number}
            onChange={handleInputOnChange}
            fullWidth
            variant="outlined"
            error={fieldErrors.number}
            helperText={fieldErrors.number || ""}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Autocomplete
            id="tags-unit-form-access"
            options={accessOptions}
            value={access}
            name="access"
            getOptionLabel={(option) => option?.label}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Acceso *"
                name="access"
                variant="outlined"
              />
            )}
            fullWidth
            error={fieldErrors.access}
            helperText={fieldErrors.access || ""}
            onChange={(e, v) => handleNewValues({ access: v })}
            noOptionsText="No se encuentra el Acceso"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Numero de Empleado *"
            name="employeeNumber"
            value={employeeNumber}
            onChange={handleInputOnChange}
            fullWidth
            variant="outlined"
            error={fieldErrors.employeeNumber}
            helperText={fieldErrors.employeeNumber || ""}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Autocomplete
            id="tags-unit-form-station"
            options={stationsList}
            value={idStation || station}
            getOptionLabel={(option) => option?.label}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Planta *"
                name="idStation"
                variant="outlined"
                error={fieldErrors.idStation}
                helperText={fieldErrors.idStation || ""}
              />
            )}
            fullWidth
            onChange={(e, v) => handleNewValues({ idStation: v })}
            noOptionsText="No se encuentra la Planta"
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <RegularButton
            color="danger"
            disabled={isLoadingComp?.loadingTags}
            onClick={onClose}
          >
            cancelar
          </RegularButton>
          <RegularButton
            color="info"
            type="submit"
            onClick={handleSubmit}
            disabled={isLoadingComp?.loadingTags}
          >
            guardar
          </RegularButton>
        </Grid>
      </Grid>
    </form>
  );
};
